import React from "react";
import AuthGuard from "./AuthGuard";

const CreateAdvertiser = React.lazy(() =>
  import("../pages/AdvertiserManagement/CreateAdvertiser")
);
const ManageAdvertisers = React.lazy(() =>
  import("../pages/AdvertiserManagement/ManageAdvertisers")
);

const AdvertiserRoutes = [
  {
    path: "advertiser/createadvertiser",
    element: (
      <AuthGuard>
        <CreateAdvertiser />
      </AuthGuard>
    ),
  },
  {
    path: "advertiser/editadvertiser/:id",
    element: (
      <AuthGuard>
        <CreateAdvertiser />
      </AuthGuard>
    ),
  },
  {
    path: "advertiser/manageadvertisers",
    element: (
      <AuthGuard>
        <ManageAdvertisers />
      </AuthGuard>
    ),
  },
];

export default AdvertiserRoutes;
